import { registerUpgrade } from '../../../logic/requests/events';
import { setupEventPayment } from '../../../logic/requests/payments.js';
import downloadFile from '../../../utils/downloadFile.js';

import REGISTER_STATUS from '../../constants/register_status.json';

import { getString } from '../../../strings';
import { getDateTimeString } from '../../../logic/eventtime.js';
import { getFileNameFromContentDispostionHeader } from '../../../logic/file.js';

export const handleRegisterUpgrade = (event, setEvent) => {
    registerUpgrade(event.id)
        .then((res) => {
            setEvent({
                ...event,
                user_register_status: 1,
            });
        })
        .catch((err) => {
            console.error('registerUpgrade', err);
        });
};

export const handlePay = (event, setPaymentDeadlinePopup, setRegistrationClosedPopup, setEvent) => {
    // TODO: Pokazać tu loader?
    setupEventPayment(event.id)
        .then((res) => {
            if (!res.token) {
                // TODO: pokazać błąd? to nie powinno się zdażyć
                return;
            }
            // TODO: Pokazać coś chwilę przed przekierowaniem?
            const service =
                process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'uat'
                    ? 'secure'
                    : 'sandbox';
            window.location = `https://${service}.przelewy24.pl/trnRequest/${res.token}`;
        })
        .catch((err) => {
            if (err.data.code) {
                switch (err.data.code) {
                    case 'deadline':
                        setEvent({
                            ...event,
                            pending_deadline_expired: 1,
                        });
                        setPaymentDeadlinePopup?.(
                            getDateTimeString(new Date(event.pending_deadline))
                        );
                        break;
                    case 'closed_registration':
                        setEvent({
                            ...event,
                            register_status: 'closed',
                        });
                        setRegistrationClosedPopup?.(
                            getDateTimeString(new Date(event.register_time_end))
                        );
                        break;
                    default:
                        break;
                }
            }
        });
};

export const REGISTER_STATUS_TEST = {
    [REGISTER_STATUS['UNCONFIRMED']]: getString('userPanel_userPanelTournament_oczekujacy'),
    [REGISTER_STATUS['CONFIRMED']]: getString('userPanel_userPanelTournament_zatwierdzony'),
    [REGISTER_STATUS['REJECTED']]: getString('userPanel_userPanelTournament_odrzucony'),
    [REGISTER_STATUS['TRANSACTION_PENDING']]: getString(
        'userPanel_userPanelTournament_platnosc_w_toku'
    ),
};

export const downloadCubeComps = async (event) =>
    await downloadFile(`/api/event-management/cubecomps/${event.id}`, `cubecomps_${event.code}.csv`);

export const downloadContactList = async (event) =>
    await downloadFile(
        `/api/event-management/contact-list/${event.id}`,
        `lista_kontaktowa_${event.code}.csv`
    );

export const downloadABCD = async (event) =>
    await downloadFile(`/api/event-management/abcd/${event.id}`, `abcd_${event.code}.csv`);

export const downloadIDCards = async (eventCode, users) => {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json');

    return fetch(`/api/event-management/get-ids/${eventCode}`, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
            persons: users,
        }),
    })
        .then(async (res) => ({
            filename: getFileNameFromContentDispostionHeader(
                res.headers.get('content-disposition')
            ),
            blob: await res.blob(),
        }))
        .then((resObj) => {
            const newBlob = new Blob([resObj.blob], { type: 'application/pdf' });

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(newBlob);
            } else {
                const objUrl = window.URL.createObjectURL(newBlob);

                let link = document.createElement('a');
                link.href = objUrl;
                link.download = resObj.filename;
                link.click();

                setTimeout(() => {
                    window.URL.revokeObjectURL(objUrl);
                }, 250);
            }
        })
        .catch((error) => {
            console.log('DOWNLOAD ERROR', error);
        });
};

export const downloadThanksCards = async (event, list_names, empty_pages) => {
    const queryParams = new URLSearchParams();
    if (list_names?.length > 0) {
        queryParams.append('list_names', list_names);
    }
    if (empty_pages) {
        queryParams.append('empty_pages', empty_pages);
    }

    return downloadFile(
        `/api/event-management/get-thanks/${event.id}?${queryParams.toString()}
        `,
        `thanks_${event.code}.pdf`
    );
};

export const downloadDiplomaCards = async (event) =>
    await downloadFile(`/api/event-management/get-diploma/${event.id}`, `diplomas_${event.code}.pdf`);

export const downloadMedalsCards = async (event) =>
    await downloadFile(`/api/event-management/get-medals/${event.id}`, `medals_${event.code}.pdf`);

export const downloadCupsCards = async (event) =>
    await downloadFile(`/api/event-management/get-cups/${event.id}`, `cups_${event.code}.pdf`);

export const downloadCompetitors = async (event) =>
    await downloadFile(
        `/api/event-management/competitors-csv/${event.id}`,
        `zawodnicy_${event.code}.csv`
    );
